export const CURRENCY = 'AED';
